import { API_ORIGIN } from "../services/api";

const placeholderSvg = encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240">
    <rect width="320" height="240" rx="24" fill="#f1f7fd"/>
    <rect x="78" y="62" width="164" height="116" rx="18" fill="#ffffff" stroke="#cfe2f7" stroke-width="4"/>
    <circle cx="126" cy="106" r="18" fill="#3991D5" opacity=".18"/>
    <path d="M96 158l48-42 34 30 24-20 34 32H96z" fill="#3991D5" opacity=".28"/>
    <text x="160" y="207" text-anchor="middle" font-family="Arial, sans-serif" font-size="15" font-weight="700" fill="#64748b">Image pending</text>
  </svg>
`);

export const PRODUCT_IMAGE_PLACEHOLDER = `data:image/svg+xml;charset=utf-8,${placeholderSvg}`;

export function resolveProductImage(image) {
  const source = typeof image === "string"
    ? image
    : image?.src || image?.url || image?.thumbnail || image?.source_url || "";
  const value = String(source || "").trim();

  if (!value) return PRODUCT_IMAGE_PLACEHOLDER;
  if (value.startsWith("data:")) return value;
  if (value.startsWith("http://") || value.startsWith("https://")) return value;
  if (value.startsWith("//")) return `https:${value}`;
  if (value.startsWith("/uploads")) return `${API_ORIGIN}${value}`;
  if (value.startsWith("uploads/")) return `${API_ORIGIN}/${value}`;
  if (value.startsWith("/wp-content")) return `https://bobbinusa.com${value}`;
  if (value.startsWith("wp-content/")) return `https://bobbinusa.com/${value}`;
  return PRODUCT_IMAGE_PLACEHOLDER;
}

export function productDetailImages(product) {
  const images = [product?.image, ...(product?.images || [])];
  const resolved = images.filter(Boolean).map(resolveProductImage);
  const unique = [...new Set(resolved)];
  return unique.length ? unique : [PRODUCT_IMAGE_PLACEHOLDER];
}
